import { Tooltip } from '@mantine/core';
import { IconAlertCircleFilled } from '@tabler/icons-react';
import type { Issue } from '../../shared/contracts';
import { SECTION_TITLES, type PortalSection } from '../../shared/pages';
import { ISSUES, issueLabel, type SectionIssues } from '../issues';
import { Link } from './Link';
import { classNames } from '../classNames';

export function IssuesBadge({ issues }: { issues: SectionIssues }) {
  return (Object.keys(SECTION_TITLES) as PortalSection[]).flatMap((section) =>
    (issues[section] ?? []).map((issue) => (
      <IssueBadge
        key={`${section}-${issue.kind}`}
        section={section}
        issue={issue}
      />
    )),
  );
}

function IssueBadge({
  section,
  issue,
}: {
  section: PortalSection;
  issue: Issue;
}) {
  const { badgeLabel } = ISSUES[issue.kind];
  const label = issueLabel(issue);
  return (
    <Tooltip
      label={`${label}.`}
      events={{ hover: true, focus: true, touch: true }}
      multiline
      maw={300}
      withArrow
    >
      <Link
        href={`/${section}`}
        aria-label={`${badgeLabel}. ${label}. Open ${SECTION_TITLES[section]}.`}
        className={classNames(
          'focus-visible:outline-brand portal-press flex items-center gap-1.5 rounded-sm border px-2 py-0.5 text-sm font-medium whitespace-nowrap text-white hover:opacity-75 focus-visible:outline-2 focus-visible:outline-offset-4',
          issue.kind === 'activity-waiver'
            ? 'border-warning/50 bg-warning/10'
            : 'border-attention/50 bg-attention/10',
        )}
      >
        <IconAlertCircleFilled
          size={18}
          aria-hidden
          className={
            issue.kind === 'activity-waiver' ? 'text-warning' : 'text-attention'
          }
        />
        <span className="max-sm:sr-only">{badgeLabel}</span>
      </Link>
    </Tooltip>
  );
}
